import React from 'react'
import ModalAuth from './ModalAuth'
import HalloweenProvider from '../halloween/Halloween'

function GlobalModalLayout({ children }) {
  // importar todos los modales que seran globales aqui

  return (
    <HalloweenProvider>
      <ModalAuth />
      {children}
    </HalloweenProvider>
  )
}

export default GlobalModalLayout
